import {
    PRESUPUESTADOR_SET_BONIFICATION_TAKING_CAR_BEGIN,
    PRESUPUESTADOR_SET_BONIFICATION_TAKING_CAR_SUCCESS,
  
  } from '../constants'
  
  export function setBonificationTakingCar(bonificationAmount, usedCarIndex, isDelete = false, takeImprovementAmount = 0) {
    return dispatch => {
      // optionally you can have getState as the second argument
      dispatch({
        type: PRESUPUESTADOR_SET_BONIFICATION_TAKING_CAR_BEGIN,
        data: { usedCarIndex },
      })
  
      dispatch({
        type: PRESUPUESTADOR_SET_BONIFICATION_TAKING_CAR_SUCCESS,
        data: { bonificationAmount, usedCarIndex, isDelete, takeImprovementAmount },
      })
  
    }
  }
  